import { DataGridProvider } from '../data-grid/DataGridContext';
import ProjectTable from '../ProjectTable';
import { Collapse } from 'antd';
import SampleProjectModal from '../SampleProjectModal';
import React from 'react';

export default function CloudProjects({ onUpload }) {
    return (
        <div
            style={{
                maxHeight: window.innerHeight / 2,
                width: 1400,
                overflowY: 'auto',
            }}
        >
            <DataGridProvider>
                <ProjectTable
                    onUpload={onUpload}
                    bottom={() => (
                        <Collapse style={{ border: 'none' }}>
                            <Collapse.Panel
                                key={'sp'}
                                showArrow={false}
                                style={{
                                    margin: 0,
                                    padding: 0,
                                    backgroundColor: '#fff',
                                    border: 'none',
                                }}
                                header={
                                    <div
                                        className={'project-warning'}
                                        style={{
                                            display: 'flex',
                                            alignItems: 'center',
                                            gap: 16,
                                            backgroundColor: '#E2F0D9',
                                            border: '1px solid #70AD47',
                                            padding: 8,
                                            width: '100%',
                                            textAlign: 'left',
                                            cursor: 'pointer',
                                        }}
                                    >
                                        <br />
                                        <p style={{ margin: 0 }}>
                                            Don't you have a one-dimensional
                                            HEC-RAS model to test at hand?
                                            <br />
                                            No worries! Click here to select
                                            from the test models.
                                        </p>
                                        <br />
                                    </div>
                                }
                            >
                                <SampleProjectModal onUpload={onUpload} />
                            </Collapse.Panel>
                        </Collapse>
                    )}
                />
            </DataGridProvider>
        </div>
    );
}
